import RegenerateAuthToken from './RegenerateAuthToken';

export default RegenerateAuthToken;
